export default __webpack_public_path__ + "static/media/samandehi.ea4f5270.png";